import { useContractPermissions } from 'commerce-contract-lib/hooks/useContractPermissions';
export const COMMON_VALIDATION_ERRORS = {
  unauthorized: 'unauthorized',
  jitaUser: 'jitaUser'
};
export function useCommonValidation({
  objectId,
  objectTypeId,
  skip
}) {
  const permissions = useContractPermissions({
    objectId,
    objectTypeId,
    skip
  });
  if (permissions.isJitaUser()) {
    return COMMON_VALIDATION_ERRORS.jitaUser;
  }
  if (!permissions.hasWrite()) {
    return COMMON_VALIDATION_ERRORS.unauthorized;
  }
  return null;
}